export enum IRegExpPattern {
  NUMERIC = 'numeric',
  ALPHANUMERIC = 'alphanumeric',
  POSTAL_CODE = 'code postal',
  PHONE_NUMBER = 'numéro de téléphone',
  EMAIL = 'email'
}
